import { useDimension } from '@openeducation/oe-rn-themes';

export type FontSizes =
  | 'extraSmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'extraLarge';

const FontSizesDesktop = {
  extraSmall: 16,
  small: 24,
  medium: 32,
  large: 40,
  extraLarge: 48,
};

const FontSizesMobile = {
  extraSmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  extraLarge: 40,
};

export function useOETextFontSize() {
  const { isDesktop } = useDimension();

  function getFontSize(size: FontSizes) {
    return isDesktop ? FontSizesDesktop[size] : FontSizesMobile[size];
  }

  return {
    getFontSize,
  };
}
